/*========================================================================================================================================================
  #                                                                 GLOBAL FUNCTIONS
==========================================================================================================================================================*/
 
const currentUrl = window.location.href;

function sayHello(){
  return console.log("hello")
}
function isProductPage(){
  return currentUrl.includes("/products/")
}
function isWishlistPage(){
  return currentUrl.includes("/wishlist")
}
function isCollectionPage(){
  return currentUrl.includes("/collections/")
}
function isSearchPage(){
  return currentUrl.includes("/search")
}
function isCartPage(){
  return currentUrl.includes("/cart")
}
function isContactPage(){
  return currentUrl.includes("/contacta")
}


// --------- DO something  when in collection page more products are loaded ---------
function doItWhenProductListGrows(callback) {
    function handleChildCountChange(mutationsList, observer) {
        for(let mutation of mutationsList) {
            if (mutation.type === 'childList') {      
                let numberOfChildren = mutation.target.children.length;
                console.log('Number of children changed to:', numberOfChildren);
                callback();
            }
        }
    }
    let targetNode = document.querySelector('.product-list');
    let config = { childList: true };
    let observer = new MutationObserver(handleChildCountChange);
    if (targetNode) {
        observer.observe(targetNode, config);
    } 
}
/* =================================================================================================
  #                                 DESKTOP QUICKBUY ON PRODUCT CARD                       
=================================================================================================== */
function waitForSectionToBeLoaded() {
  if (isProductPage()) {
      const outerObserver = new MutationObserver((mutationsList, observer) => {
       const parentElement = document.querySelector('.shopify-section--related-products');
       const targetElement = parentElement.querySelector('.product-card');
       if (targetElement) {
         observer.disconnect(); 
         pangoQuickBuy();
       }
     });
     outerObserver.observe(document.documentElement, { childList: true, subtree: true }); 
  }
}

function isCollectionPageFilterClicked(){
  if(isCollectionPage()){
    let previousUrl = "";
    const observer = new MutationObserver(function (mutations) {
      if (window.location.href !== previousUrl) {
        previousUrl = window.location.href;
        setTimeout(() => {
          pangoQuickBuy();
        }, 200);
      }
    });
    const myConfig = { subtree: true, childList: true };
    observer.observe(document, myConfig);     
  }
}

function pangoQuickBuy() {
  // Show quick buy section on click
  const quickBuyBtns = document.querySelectorAll('[pango="quick-buy"]')
  quickBuyBtns.forEach(quickBtn => {
    quickBtn.addEventListener('click', () => {
      let productHandle = quickBtn.getAttribute('product-handle');
      let quickBuySections = document.querySelectorAll(`[pango-quick-add-handle]`);
      quickBuySections.forEach( quickBuy => {
        let quickBuySection = quickBuy.getAttribute('pango-quick-add-handle');
        if (productHandle === quickBuySection) {
          quickBuy.classList.remove("hide");
          quickBuy.classList.add("f-col");
        } else {
          quickBuy.classList.remove("f-col");
          quickBuy.classList.add("hide");
        }
      })
    })
  })
  
  // Close quick buy section on click
  const closeQuickBuyBtns = document.querySelectorAll('[pango-quick-add-close-btn]');
  closeQuickBuyBtns.forEach( closeBtn => {
    closeBtn.addEventListener('click', () => {
      let btnAttribute = closeBtn.getAttribute('pango-quick-add-close-btn');
      let quickBuySection = document.querySelector(`[pango-quick-add-handle=${btnAttribute}]`);
      quickBuySection.classList.remove('f-col');
      quickBuySection.classList.add('hide');
    })
  })
  
  
  const allCards = document.querySelectorAll('[pango-quick-add-handle]')
  allCards.forEach(card =>  {
    pangoGetProductInfo(card)
  })
}


function pangoGetProductInfo(card){
  let productDataElement = card.querySelector('.pangoShopifyDataProductCard script[type="application/json"]')
  let product =  JSON.parse(productDataElement.textContent)
  const productVariants =  product.variants ;

  updateVariantID(card,productVariants)
  updateCart(card)
      
  // Event listener for option selectors
  card.querySelectorAll('.quick-option-selector').forEach(select => {
    select.addEventListener('change', () => updateVariantID(card));
  });
  card.querySelectorAll('.quantity-selector__button').forEach(button => {
    button.addEventListener('click', () => updateQuantity(card));
  })
}
 
function updateVariantID(card) {
  let productDataElement = card.querySelector('.pangoShopifyDataProductCard script[type="application/json"]')
  let product =  JSON.parse(productDataElement.textContent)
  const productVariants =  product.variants ;
  
  // Collect selected options
  const selectedOptions = Array.from(card.querySelectorAll('.quick-option-selector')).map(select => select.value);

  // Find matching variant based on selected options
  const matchingVariant = productVariants.find(variant => 
    variant.options.every((option, index) => option === selectedOptions[index])
  );
  if ( matchingVariant ) {
    const selectedVariantId = matchingVariant.id;
    let optionInput = card.querySelector('[selected-product="product-id"]')
    let optionPrice = card.querySelector('[data-product-price="product-price"]')
    let inputQuantity = card.querySelector('.quantity-selector__input');
    optionInput.value = selectedVariantId
    let price = Number(matchingVariant.price/100) * inputQuantity.value
    optionPrice.textContent = price.toLocaleString('es-ES', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
}

function updateQuantity(card) {
  let inputQuantity = card.querySelector('.quantity-selector__input');
  let quantityForm = card.querySelector('#quantity');
  quantityForm.value = inputQuantity.value;
  updateVariantID(card);
}

async function updateCart(card) { 
  const form = card.querySelector('form');

  // Ensure you don't attach the listener multiple times
  if (form && !form.hasAttribute('data-listener-attached')) {
    form.addEventListener('submit', async function(event) {

      // Prevent the default form submit (which redirects to /cart)
      event.preventDefault();

      // Collect form data
      const formData = new FormData(this); 

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        const data = await response.json();

        // Dispatch the cart refresh event
        document.dispatchEvent(new CustomEvent("cart:refresh", {
          detail: { cart: data }
        }));

        // Open the cart drawer
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.show();
        } 

      } catch (error) {
        console.error('Error adding item to cart:', error);
      }
    });

    // Mark that the listener has been attached to prevent re-binding
    form.setAttribute('data-listener-attached', 'true');
  }
}



// ---------------------- START ---------------------
document.addEventListener('DOMContentLoaded', () => {
  pangoQuickBuy();
  waitForSectionToBeLoaded();
  isCollectionPageFilterClicked();
  doItWhenProductListGrows(pangoQuickBuy)
})
 


/* =================================================================================================
  #    POP UP se llama en p-modal.liquid                       
              se usa en p-cards.liquid, en p-proyectos.liquid
=================================================================================================== */
function pangoModal(sectionId){
    let parent = document.querySelector(`.p-${sectionId}`)
    const myModal = parent.querySelector(`#p-modal`);
    const closeMyModal = parent.querySelector("#Close-my-modal");
    
    closeMyModal.addEventListener("click", () => {
      myModal.classList.remove('mostrar');
      setTimeout(() => myModal.close(), 500);
    });
  
    let sectionLinksWrapper = parent.querySelector('.p-modal-link-wrapper');
    let all_links = sectionLinksWrapper.querySelectorAll('a');
    
    all_links.forEach((link, index) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        myModal.showModal();
        myModal.classList.add('mostrar');
        setTimeout(() => {
          const targetDiv = parent.querySelector(`#sect-${index + 1}`);
          if (targetDiv) {
            targetDiv.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
  
      });
    });
  
    // Cerrar dialog al pulsar fuera del contenido
    myModal.addEventListener('click', (e) => {
    const rect = myModal.getBoundingClientRect();
    if (
      e.clientX < rect.left ||
      e.clientX > rect.right ||
      e.clientY < rect.top ||
      e.clientY > rect.bottom
    ) {
      myModal.classList.remove('mostrar');
      setTimeout(() => myModal.close(), 500);
    }
  });
  
}
/* =================================================================================================
  #                                                       
=================================================================================================== */
